<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">IDENTITAS DIRI</h6>
        <b-row v-if="isEdit">
            <b-col>
                <b-button
                        variant="pgiBtn"
                        @click="$bvModal.show('modal-identitas-list-c')"
                    >
                    Lihat Identitas
                </b-button>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="6">
                <b-form-group label="Jenis Identitas">
                    <b-form-select
                        v-model="dataIdentitasDiri.jenisIdentitasDiri"
                        name="jenisIdentitas"
                        :options="jenisIdentitas"
                        style="max-width: 100%;"
                        required
                        >
                        <template v-slot:first>
                            <b-form-select-option
                                :value="null"
                                disabled
                                >
                                -- Please select an option --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label="Nomor Identitas">
                    <b-form-input
                        v-model="dataIdentitasDiri.nomorIdentitasDiri"
                        maxlength="32"
                        placeholder="cth: 3201xxxxxxxxxxxx"
                        name="nomorIdentitasDiri"
                        style="max-width: 100%;"
                        required
                        >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group label="Foto Identitas">
                    <div class="foto-input-wrapper" style="max-width: 247px;">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataIdentitasDiri.activeFotoIdentitasDiriBase64)">
                                <img :src="dataIdentitasDiri.activeFotoIdentitasDiriBase64" :key="dataIdentitasDiri.activeFotoIdentitasDiriBase64" alt="Foto Identitas">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview()">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataIdentitasDiri.fotoIdentitasDiri" name="fotoIdentitasDiri"
                                    :state="Boolean(dataIdentitasDiri.fotoIdentitasDiri)"
                                    placeholder="Foto Identitas Diri"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput"
                                    @click.native="rememberCurrentFile()"
                                    @change.native="browseFile()"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera()">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- MOBILE -->
                        </div>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <label style="font-weight: bold">* Contoh pengambilan foto</label>
                <div class="foto-input-wrapper">
                    <div class="foto-preview-wrapper-potrait">
                        <img
                            src="/img/Screenshot 2023-06-19 at 11.40.20.jpg"
                            alt="Contoh KTP"
                        />
                    </div>
                </div>
            </b-col>
        </b-row>
        <input
            style="display: none;"
            ref="cameraInput"
            type="file" 
            accept="image/*" 
            capture="environment" 
            @change="handleKameraMobile"
        />
        <ModalPreview modalId="modal-preview-identitas" :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import ModalPreview from '../../components/webcam/ModalPreview'

export default {
    name: 'data-identitas-diri',
    props: {
        dataIdentitasDiri: { type: Object, default: () => ({}) },
        jenisIdentitas: { type: Array, default: () => ([]) },
        isEdit: { type: Boolean, default: false },
        dataEdit: { type: Object, default: () => ({}) },
    },
    components: {
        ModalPreview,
    },
    data() {
        return {
            activeFotoPreview: '',
            lastFotoIdentitasDiri: null,
        }
    },
    methods: {
        rememberCurrentFile() {
            if (this.dataIdentitasDiri.fotoIdentitasDiri) {
                this.lastFotoIdentitasDiri = this.dataIdentitasDiri.fotoIdentitasDiri
            }
        },

        browseFile() {
            let file = this.dataIdentitasDiri.fotoIdentitasDiri

            if (!file) {
                this.dataIdentitasDiri.fotoIdentitasDiri = this.lastFotoIdentitasDiri
                return
            }

            this.lastFotoIdentitasDiri = file

            this.toBase64(file)
                .then(async base64 => {
                    this.dataIdentitasDiri.activeFotoIdentitasDiriBase64 = await this.$helper.resizeImage(base64)
                })
                .catch(error => {
                    console.log(error)
                    this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        openModalPreview(url) {
            if (url) {
                this.activeFotoPreview = url;
            } else {
                this.activeFotoPreview = this.dataIdentitasDiri.activeFotoIdentitasDiriBase64;
            }
            this.$bvModal.show("modal-preview-identitas");
        },

        onCamera() {
            this.$refs.cameraInput.click();
        },

        handleKameraMobile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.dataIdentitasDiri.fotoIdentitasDiri = file;
            this.browseFile();
        }
    },
}

</script>
